import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { TextBox } from "../../core/components/textBox";
import { FieldInstance } from "../../core/components/field";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { Helper } from "../../core/util/helper";
import { ComponentHelper } from "../../core/util/componentHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { ContextGeneralSettingsApp } from "../generalSettings";
import React from "react"
export default class EditQuanosCatalog extends React.Component<{ context: ContextGeneralSettingsApp }, EditQuanosCatalogState> {
    private _translations: string[] = null;
    private _options: any = null;
    private _factory = ComponentHelper.createFactory();
    private _fullLoaded: boolean;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (this._checkData()) {
                        this._save();
                    } else {
                        DialogHelper.alert(this._translations["Standard.PflichtfeldAllgemein"]);
                        return false;
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this._fullLoaded = false;
        this.state = { gridData: [], deleteButtonEnabled: false, dialogOpen: false, currentItem: null };
    }

    private _checkData = () => {
        return !Helper.isNullOrEmpty(this.state.currentItem.Id) && 
            !Helper.isNullOrEmpty(this.state.currentItem.DisplayName) &&
            !Helper.isNullOrEmpty(this.state.currentItem.TechnicalName);
    }

    private _getGridData = () => {
        let url = "GeneralSettingsQuanos/GetCatalog";
        HTTPService.get<JsonResultClass<QuanosCatalogViewModel[]>>(url)
            .then(result => {
                if (result.Code == 0) {
                    this.setState({ gridData: result.Data });
                }
            });
    }

    private _save = () => {
        let url = "GeneralSettingsQuanos/SaveCatalog"
        HTTPService.post<JsonResultClass>(url, { model: this.state.currentItem }).then(result => {
            if (result.Code == 0) {
                this._getGridData();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }

    private _createDialog = () => {
        if (this.state.dialogOpen) {
            return (
                <div>
                    <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                        <FullHeightContainer>
                            {this._createIdBox()}
                            {this._createDisplayNameTextBox()}
                            {this._createTechnicalNameTextBox()}
                        </FullHeightContainer>
                    </Dialog>
                </div>
        );
        } else {
            return (<></>);
        }
    }
    
    private _createDisplayNameTextBox = () => {
        let props = this._factory.getDefaultTextBoxProps();
        props.value = this.state.currentItem.DisplayName;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let item = this.state.currentItem;
            item.DisplayName = value;
            this.setState({ currentItem: item });
        }
        return (
            <FieldInstance label={Helper.getTranslation("WebSMS.Quanos.DisplayName") + " *"} noHover={true}>
            <TextBox {...props} />
        </FieldInstance>
    );
    }

    private _createTechnicalNameTextBox = () => {
        let props = this._factory.getDefaultTextBoxProps();
        props.value = this.state.currentItem.TechnicalName;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let item = this.state.currentItem;
            item.TechnicalName = value;
            this.setState({ currentItem: item });
        }
        return (
            <FieldInstance label={Helper.getTranslation("WebSMS.Quanos.TechnicalName") + " *"} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private _getNextNumber = (): Promise<number> => {
        return new Promise<number>(async (resolve) => {
            let result = await HTTPService.get<JsonResultClass<number>>(
                "GeneralSettingsQuanos/GetNextNumber")
            resolve(result.Data);
        });
    }
    
    private _createIdBox =  () => {
            let props = this._factory.getDefaultTextBoxProps();
            props.value = this.state.currentItem.Id;
            props.disabled = true;
            return(
                <FieldInstance label={this._translations["Standard.Key"]} noHover={true}>
                    <TextBox {...props} />
                </FieldInstance>
            );
    }
    
    private _delete = (dataItem: QuanosCatalogViewModel) => {
        DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                let url = "GeneralSettingsQuanos/DeleteCatalog";
                HTTPService.post<JsonResultClass>(url, { id: dataItem.Id }).then(result => {
                    if (result.Code == 0) {
                        this._getGridData();
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
            }
        });
    }

    private _openDialog = async (dataItem: QuanosCatalogViewModel = null) => {
        if (!Helper.hasValue(dataItem)) {
            const id = await this._getNextNumber();
            dataItem = {
                Id: id.toString(),
                DisplayName: "",
                TechnicalName: ""
            };
        }
        this.setState({ dialogOpen: true, currentItem: { ...dataItem } })
    }

    private _createGrid = () => {
        
        const active = (this.props as any).entity.QuanosSettings.Active;
        
        if (this._fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: active });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: active });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: active && this.state.deleteButtonEnabled });
            let grid = (
                <Grid 
                    data={this.state.gridData} 
                    options={this._options} 
                    id="generalSettings_QuanosCatalogGrid" 
                    onSelectionChanged={this._handleSelectedChange}
                    standardButtons={standardButtons} 
                    onClickStandardButton={this._handleClickStandardButton}
                />
            );
            return (
                <div style={{ height: "300px" }}>
                    {grid}
                </div>
            )
        } else {
            return (<></>);
        }
    }

    private _handleSelectedChange = (dataItem: QuanosCatalogViewModel) => {
        this.setState({ deleteButtonEnabled: Helper.hasValue(dataItem) })
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: QuanosCatalogViewModel) => {
        switch (type) {
            case (ToolBarStandardButtonType.EDIT):
                this._openDialog(dataItem)
                break;
            case (ToolBarStandardButtonType.NEW):
                this._openDialog()
                break;
            case (ToolBarStandardButtonType.DELETE):
                this._delete(dataItem);
                break;
        }
    }
    componentDidMount() {
        this._translations = this.props.context.translations;
        this._options = this.props.context.quanosCatalogGridOptions;
        this._fullLoaded = true;
        this._getGridData();
        
    }

    render() {
        const grid = this._createGrid();
        const dialog = this._createDialog();
        return (
            <>
                {grid}
                {dialog}
            </>);
    }
};
interface EditQuanosCatalogState {
    dialogOpen: boolean;
    deleteButtonEnabled: boolean;
    currentItem: QuanosCatalogViewModel;
    gridData: QuanosCatalogViewModel[];
}
interface QuanosCatalogViewModel {
    Id: string;
    DisplayName: string;
    TechnicalName: string;
}